<template>
  <v-autocomplete
    :items="currenciesList"
    v-model="selectedCurrency"
    :label="label"
    :item-text="currencyText"
    item-value="code"
    @change="changeListener"
    :disabled="!enabled"
    :error-messages="errorMessages"
    :outlined="outlined"
    :hide-details="hideDetails"
    :dense="dense"
  ></v-autocomplete>
</template>

<script>
import { ALL_CURRENCIES_SEARCH_QUERY } from "../../../constants/graphql";

export default {
  name: "CurrencyListSelect",

  props: {
    outlined: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    customLabel: { type: String },
    value: { type: String },
    currencyCode: { type: String, default: () => "" },
    includeExchangeRate: {
      type: Boolean,
      default: () => false,
    },
    enabled: {
      type: Boolean,
      default: () => true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    showCodeAsName: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: () => "",
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      currencies: {},
      currenciesList: [{ name: "Euro", code: "eur" }],
      selectedCurrency: this.value != "" ? this.value : null,
    };
  },

  methods: {
    changeListener(data) {
      if (typeof data === "string") {
        if (this.includeExchangeRate) {
          const selectedCurrency = this.currenciesList.find(
            (c) => c.code === data
          );
          if (selectedCurrency) {
            this.$emit("onSelect", selectedCurrency);
          }
        } else {
          this.$emit("onSelect", data);
        }
        this.$emit("input", data);
      }
    },
  },

  computed: {
    label() {
      return this.customLabel ? this.customLabel : "Currency";
    },
    currencyText() {
      return this.showCodeAsName ? "code" : "name";
    },
  },

  watch: {
    currencyCode(data) {
      if (data != "") {
        this.selectedCurrency = data;
      }
    },
    value(newVal) {
      this.selectedCurrency = newVal != "" ? newVal : null;
    },
  },

  apollo: {
    currencies: {
      query: ALL_CURRENCIES_SEARCH_QUERY,
      variables() {
        return {
          includeExchangeRate: this.includeExchangeRate,
        };
      },
      result({ data, loader, networkStatus }) {
        this.currenciesList = data.currencies.edges.map((curr) => ({
          ...curr.node,
        }));
        if (this.includeExchangeRate && this.value) {
          const selectedCurrency = this.currenciesList.find(
            (c) => c.code === this.value
          );
          if (selectedCurrency) {
            this.$emit("onSelect", selectedCurrency);
          }
        }
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/CurrencyListSelect.vue